var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.504 10.188-1.785-.215a7.969 7.969 0 0 0-.793-1.92l1.11-1.41a.579.579 0 0 0-.046-.748l-1.84-1.84a.58.58 0 0 0-.747-.046L15.99 5.121a7.86 7.86 0 0 0-1.916-.792l-.214-1.785a.58.58 0 0 0-.56-.496h-2.602a.578.578 0 0 0-.559.496l-.214 1.785c-.68.181-1.324.45-1.919.792l-1.412-1.11a.58.58 0 0 0-.746.046l-1.84 1.84a.58.58 0 0 0-.043.748l1.109 1.41a7.903 7.903 0 0 0-.793 1.92l-1.784.214a.579.579 0 0 0-.497.56v2.602a.58.58 0 0 0 .497.559l1.785.214c.182.679.448 1.322.792 1.917l-1.108 1.413a.58.58 0 0 0 .045.747l1.837 1.84a.58.58 0 0 0 .746.046l1.413-1.112a7.873 7.873 0 0 0 1.919.793l.214 1.784a.578.578 0 0 0 .56.496h2.6a.577.577 0 0 0 .56-.496l.214-1.784a7.942 7.942 0 0 0 1.919-.793l1.413 1.11a.58.58 0 0 0 .746-.045l1.84-1.84a.58.58 0 0 0 .044-.749l-1.11-1.41a7.914 7.914 0 0 0 .793-1.918l1.784-.215A.577.577 0 0 0 22 13.35v-2.601a.576.576 0 0 0-.496-.56zm-9.503 6.86a5 5 0 1 1 0-10 5 5 0 0 1 0 10z",
    fill: "#8B909A",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.fe72d592.svg";
export { ForwardRef as ReactComponent };